import { render, staticRenderFns } from "./DomainProject.vue?vue&type=template&id=2c36a41d"
import script from "./DomainProject.vue?vue&type=script&lang=js"
export * from "./DomainProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports